module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en-us":{"appointment":"Appointment scheduled","automationName":"Appointment: {name}","description":"These automations are triggered by this appointment type. | Trigger a follow-up when a contact books or cancels an appointment.","errorLoadingAutomations":"Something went wrong and we couldn\u0027t load associated automations."}}')
  delete Component.options._Ctor
}
